import { render, staticRenderFns } from "./ValueMarketplace.vue?vue&type=template&id=1b5410f6"
import script from "./ValueMarketplace.vue?vue&type=script&lang=js"
export * from "./ValueMarketplace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports